import {
  localPartForEmail,
  otpSixRegex,
  passwordRegex,
  spaceRegExp,
  tenAlphaNumericRegex,
} from "utils/regex";
import * as Yup from "yup";

export const FName = (t) => Yup.string().required(t("validation.pleaseEnterFirstName"));

export const LName = (t) => Yup.string().required(t("validation.pleaseEnterLastName"));

export const EmailFirstPart = (t) =>
  Yup.string()
    .required(t("enterEmailError"))
    .matches(localPartForEmail, t("validEmail"))
    .min(6, t("emailLength"));


export const Password = (t) =>
  Yup.string()
    .min(8, t("validation.validPassword"))
    .matches(passwordRegex, t("validation.validPassword"))
    .matches(spaceRegExp, t("validation.validPassword"))
    .required(t("validation.pleaseEnterPassword"));


export const CNewPassword = (t) =>
  Yup.string()
    .oneOf([Yup.ref("newPassword")], t("validation.checkCompairNewPassword"))
    .required(t("validation.checkConfirmPassword"));


export const NPassword = (t) =>
  Yup.string()
    .required(t("validation.pleaseEnterNewPassword"))
    // .min(8, t("newPasswordShouldBeEightCharacters"))
    .matches(passwordRegex, t("validation.newPasswordConatinAll"));

export const VPassword = (t) =>
  Yup.string()
    // .min(8, t("passwordShouldBeEightCharacters"))
    .matches(passwordRegex, t("validation.passwordConatinAll"))
    .matches(spaceRegExp, t("validation.validPassword"))
    .required(t("validation.pleaseEnterPassword"));

export const Subject = (t) => Yup.string().required(t("validation.pleaseEnterSubject"));
export const Message = (t) => Yup.string().required(t("validation.pleaseEnterMessage"));

export const Auth6Digit2FA = (t) =>
  Yup.string()
    .required(t("enterAuthCode"))
    .matches(otpSixRegex, t("enterAuthCode"));

export const BackupCode2FA = (t) =>
  Yup.string()
    .required(t("enterBackupCode"))
    .matches(tenAlphaNumericRegex, t("enterBackupCode"));

export const FolderName = (t) =>
  Yup.string().required(t("validation.pleaseEnterFolderName"));
